// extracted by mini-css-extract-plugin
module.exports = {"text":"_6d5a1","title":"_3a813","wrapper":"_06cda","blocks":"f3aa3","button":"f4fc6"};